import styled from 'styled-components';
import variables, {fs, screenSize} from '../../utils/variables';

export const Container = styled.div`
  ${props => props.footer ? `
    color: ${variables.colors.white};

    h4 {
      color: ${variables.colors.white};
      ${fs(24)}
    }
  ` : `
    position: absolute;
    bottom: auto;
    top: 85vh;
    left: 35px;
    z-index: 500;
  `}
  
`;

export const List = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;

  ${props => props.footer ? `
    display: flex;
  ` : null}
`;

export const Item = styled.li`
  a {
    ${props => props.footer ? `
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background: ${variables.colors.white};
      border-radius: 50%;
      ${screenSize('width', 40)}
      ${screenSize('height', 40)}
      ${screenSize('margin-right', 20)}
    ` : null}

    svg path {
      ${props => props.footer ? `
        fill: ${variables.colors.blue};
      ` : `
        fill: ${props.dark ? variables.colors.backgroundDark : variables.colors.white};
      `}
      
    }

    &:hover {
      svg path {
        // fill: ${props => props.hoverColor};
        fill: ${variables.colors.red};
      }
    }
  }
`;